"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormFieldLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _formFieldLabelModule = _interopRequireDefault(require("./form-field-label.module.scss"));
var _Tooltip = require("../../tooltip/Tooltip");
var _infoCircle = require("../../../assets/icons/info-circle.svg");
var FormFieldLabel = function FormFieldLabel(_ref) {
  var id = _ref.id,
    name = _ref.name,
    role = _ref.role,
    tooltip = _ref.tooltip,
    extra = _ref.extra;
  return name ? /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: _formFieldLabelModule.default['label'],
    role: role
  }, name, tooltip && /*#__PURE__*/_react.default.createElement("div", {
    className: _formFieldLabelModule.default['tooltip-wrapper']
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    size: "medium",
    containerClassName: _formFieldLabelModule.default['tooltip'],
    title: tooltip,
    variant: "light"
  }, /*#__PURE__*/_react.default.createElement(_infoCircle.ReactComponent, {
    className: _formFieldLabelModule.default['tooltip-icon'],
    "data-testid": "".concat(id, "-tooltip-icon")
  }))), extra && /*#__PURE__*/_react.default.createElement("span", {
    className: _formFieldLabelModule.default['label-extra-info']
  }, extra)) : null;
};
exports.FormFieldLabel = FormFieldLabel;